import { Async } from '@client/new/helpers/types';
import {
  Exact,
  GetInfluencerQuery,
  useGetInfluencerQuery,
} from 'generated/graphql';
import { ApolloQueryResult } from '@apollo/client';
import {
  hasPremiumFeaturesOTPIds,
  isSubscriptionCreator,
} from '@client/new/common/offering.helpers';

type Creator = GetInfluencerQuery['creator'];
export type Influencer = NonNullable<Creator>;

type SettingsView = {
  influencer: Influencer;
  showFeatureSettings: boolean;
  refetch: (
    variables?: Partial<Exact<{ id: number }>> | undefined,
  ) => Promise<ApolloQueryResult<GetInfluencerQuery>>;
};

type SettingsViewModelParams = {
  influencerId: number;
};

export const useSettingsViewModel = ({
  influencerId,
}: SettingsViewModelParams): Async<SettingsView> => {
  const { data, loading, error, refetch } = useGetInfluencerQuery({
    variables: { id: influencerId },
    fetchPolicy: 'no-cache',
  });

  if (loading) {
    return { type: 'fetching' };
  }

  if (error || !data?.creator) {
    return { type: 'fetch-error', value: 'Could not fetch data' };
  }

  const influencer = data.creator;

  const showFeatureSettings =
    influencer.businessModel === 'legacy' &&
    (isSubscriptionCreator(influencer?.offering) ||
      hasPremiumFeaturesOTPIds(influencer?.customizations));

  return {
    type: 'fetched',
    value: {
      influencer,
      showFeatureSettings,
      refetch,
    },
  };
};
